import { StyleSheet } from 'react-native';
import { pick } from 'lodash';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import { getFontWeight, getShadow } from '../func';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};
  let { backgroundColor, borderRadius, color, height, width } = attributes;
  if (isV4) {
    color = style?.color;
    backgroundColor = style?.backgroundColor;
    borderRadius = style?.borderRadius;
    width = style?.width;
    height = style?.height;
  }

  return StyleSheet.create({
    container: {
      ...(isV4
        ? pick(attributes, [
            'marginTop',
            'marginLeft',
            'borderRadius',
            'width',
            'height',
          ])
        : pick(attributes, ['marginTop', 'marginLeft'])),
      // Override with style object properties if they exist
      ...(style?.marginTop !== undefined && {
        marginTop: style.marginTop,
      }),
      ...(style?.marginLeft !== undefined && {
        marginLeft: style.marginLeft,
      }),
      ...(style?.marginRight !== undefined && {
        marginRight: style.marginRight,
      }),
      ...(style?.marginBottom !== undefined && {
        marginBottom: style.marginBottom,
      }),
      ...(style?.margin !== undefined && {
        margin: style.margin,
      }),
      ...(!isV4 && { width, height }),
      ...(isV4 && attributes.style?.width && { width: attributes.style.width }),
      ...(isV4 &&
        attributes.style?.height && {
          height: attributes.style.height,
        }),
      ...(style?.borderRadius !== undefined && {
        borderRadius: style.borderRadius,
      }),
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
      width,
    },
    text: {
      ...(isV4 && pick(attributes, ['color', 'borderRadius'])),
      ...(!isV4 && { backgroundColor, borderRadius, color }),
      // ...(attributes.shadow.size > 0 ? getShadow(attributes) : {}),
      ...getShadow(attributes),
      fontWeight: getFontWeight(attributes),
      ...pick(attributes, [
        ...(isV4 ? ['backgroundColor'] : []),
        'fontSize',
        // 'padding',
        'opacity',
      ]),
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      ...(attributes.style?.color && { color: attributes.style.color }),
      ...(attributes.style?.backgroundColor && {
        backgroundColor: attributes.style.backgroundColor,
      }),
      ...(attributes.style?.fontSize && {
        fontSize: attributes.style.fontSize,
      }),
      ...(attributes.style?.opacity !== undefined && {
        opacity: attributes.style.opacity,
      }),
      ...(attributes.style?.borderRadius !== undefined && {
        borderRadius: attributes.style.borderRadius,
      }),
      ...((attributes.style?.borderStyle || attributes.borderStyle) !== 'none'
        ? {
            borderWidth:
              attributes.style?.borderWidth || attributes.borderWidth,
            borderColor:
              attributes.style?.borderColor || attributes.borderColor,
          }
        : {}),
      borderStyle:
        (attributes.style?.borderStyle || attributes.borderStyle) === 'none'
          ? 'solid'
          : attributes.style?.borderStyle || attributes.borderStyle,
      minHeight: isV4 ? attributes.style?.height || attributes.height : height,
      ...(!isV4 && { width }),
      paddingLeft: attributes.style?.padding || 10,
      alignSelf: 'center',
      paddingTop: 0,
      paddingBottom: 0,
      width,
    },
  });
};

export default createStyles;
